<template>
  <div class="main-hero"
  :class="`cpt-${type}`"
  >
            <GoBack :backCTA='backCTA'/>
            <div class="main-hero-content">
                <div v-if="type ==='Portfolio'" class="breadcrumbs">
                    <span class="breadcrumbs-prev">{{type}}</span>
                    <div class="breadcrumbs-divider"/>
                    <span v-if="category" class="breadcrumbs-curr">{{category.name}}</span>
                </div>
                <div class="main-hero-content-title">
                    <h1 v-html="title">
                    </h1>
                    <img src="@/assets/img/decorative_arrow.svg" class="arrow-decoration"/>
                </div>
            </div>
        </div>
</template>

<script setup>
import GoBack from '@/components/utility/GoBack.vue'

defineProps(['category', 'title', 'backCTA', 'type'])
</script>

<style lang="scss" scoped>
    .main-hero {
        @apply relative main-container
        xl:px-[200px]
        2xl:pr-0;
        ;
        &-content {
            @apply flex flex-col
            md:pl-[70px] xl:pl-0;
            .breadcrumbs {
            @apply hidden items-center h-[60px] text-2xl leading-none mb-14

            md:flex;

                &-prev {

                }
                &-divider {
                    @apply bg-ore_orange h-[100%] w-[1px] ml-[20px] mr-[30px];
                }
                &-curr {

                }
            }
            &-title {
                @apply flex flex-col
                lg:flex-row lg:items-center lg:justify-between lg:gap-8;
                h1 {
                @apply text-4xl mb-10 leading-none
                md:text-[70px] md:mb-6

                lg:max-w-[75%] lg:text-[90px] lg:mb-0;
                }
                .arrow-decoration {
                    @apply self-end flex
                    lg:self-center
                    ;
                }
            }
        }
        &.cpt-Portfolio{
            @apply pt-48 mb-14
            md:mb-[70px]
            lg:mb-[215px]
            xl:pt-44
        }
        &.cpt-Post{
            @apply pt-48 mb-14
            md:pt-[310px]
            xl:pt-[290px]
        }
    }
</style>
